import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faWhatsapp, faLinkedin, faGithub } from '@fortawesome/free-brands-svg-icons';
import { faPhone, faEnvelope, faHome, faCompass, faLanguage, faChevronDown, faCheck, faInfoCircle } from '@fortawesome/free-solid-svg-icons';
import ContactForm from './ContactForm';

const items = [
    { icon: faWhatsapp, name: 'WhatsApp', link: 'https://api.whatsapp.com/send?phone=22893492443' },
    { icon: faLinkedin, name: 'LinkedIn', link: 'https://www.linkedin.com/in/didi-orlog-sossou-48036a201/' },
    { icon: faGithub, name: 'GitHub', link: 'https://github.com/LittleDarkBug' },
    { icon: faPhone, name: 'Téléphone', link: 'tel:+22893492443' },
];

const navItems = [
    { icon: faHome, label: 'Accueil', href: '/' },
    { icon: faCompass, label: 'Projets', href: '/projects' },
]

import Link from 'next/link';
import { useRouter } from 'next/router';
import { Switch } from '@headlessui/react';
import { useEffect, useState } from 'react';


const Header = ({ enabled, setEnabled }) => {
    const [showContactForm, setShowContactForm] = useState(false);
    const router = useRouter();
    const [showTranslateDropdown, setShowTranslateDropdown] = useState(false);
    const [currentLanguage, setCurrentLanguage] = useState('fr');

    const languages = [
        { code: 'fr', name: 'Français', flag: '🇫🇷' },
        { code: 'en', name: 'English', flag: '🇺🇸' },
        { code: 'es', name: 'Español', flag: '🇪🇸' },
        { code: 'de', name: 'Deutsch', flag: '🇩🇪' },
        { code: 'zh', name: '中文', flag: '🇨🇳' },
        { code: 'ar', name: 'العربية', flag: '🇸🇦' }
    ];

    const translatePage = (langCode) => {
        if (langCode === 'fr') {
            // Retour à la version française originale
            window.location.reload();
            return;
        }

        // Utilisation de Google Translate
        const googleTranslateUrl = `https://translate.google.com/translate?sl=fr&tl=${langCode}&u=${encodeURIComponent(window.location.href)}`;
        window.open(googleTranslateUrl, '_blank');
        
        setCurrentLanguage(langCode);
        setShowTranslateDropdown(false);
    };

    // Fermer le dropdown si on clique ailleurs
    useEffect(() => {
        const handleClickOutside = (event) => {
            if (showTranslateDropdown && !event.target.closest('.translate-dropdown')) {
                setShowTranslateDropdown(false);
            }
        };

        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [showTranslateDropdown]);
    return <>
        <div className="w-full pb-2">
            <div className="flex flex-col md:flex-row w-full items-center md:justify-between">
                <p className="font-semibold font-Poppins text-xl">SDO</p>
                <div className="flex items-center space-x-1 xs:space-x-2">
                    {/* Bouton de traduction - masqué en mobile */}
                    <div className="relative translate-dropdown hidden md:block">
                        <button
                            onClick={() => setShowTranslateDropdown(!showTranslateDropdown)}
                            className="flex items-center justify-center hover:bg-neutral-700/20 rounded-xl transition-all duration-150 p-2 px-3 relative"
                            title="Traduire la page"
                            aria-label="Traduire la page"
                        >
                            <FontAwesomeIcon icon={faLanguage} className="text-2xl mr-1" />
                            <span className="text-xs">{languages.find(lang => lang.code === currentLanguage)?.flag}</span>
                            <FontAwesomeIcon icon={faChevronDown} className="text-xs ml-1" />
                        </button>

                        {showTranslateDropdown && (
                            <div className={`absolute top-full right-0 mt-2 w-48 rounded-lg shadow-lg border z-50 ${
                                enabled 
                                    ? 'bg-gray-800 border-gray-700' 
                                    : 'bg-white border-gray-200'
                            }`}>
                                <div className="py-2">
                                    <div className={`px-3 py-2 text-xs font-semibold border-b ${
                                        enabled 
                                            ? 'text-gray-300 border-gray-700' 
                                            : 'text-gray-500 border-gray-200'
                                    }`}>
                                        <FontAwesomeIcon icon={faLanguage} className="mr-2" />
                                        Choisir une langue
                                    </div>
                                    {languages.map((lang) => (
                                        <button
                                            key={lang.code}
                                            onClick={() => translatePage(lang.code)}
                                            className={`w-full text-left px-3 py-2 text-sm flex items-center hover:bg-opacity-20 transition-all duration-150 ${
                                                currentLanguage === lang.code
                                                    ? enabled
                                                        ? 'bg-orange-600/20 text-orange-400'
                                                        : 'bg-orange-100 text-orange-600'
                                                    : enabled
                                                        ? 'text-gray-300 hover:bg-gray-700'
                                                        : 'text-gray-700 hover:bg-gray-100'
                                            }`}
                                            aria-label={`Traduire en ${lang.name}`}
                                        >
                                            <span className="mr-3 text-lg">{lang.flag}</span>
                                            <span className="flex-1">{lang.name}</span>
                                            {currentLanguage === lang.code && (
                                                <FontAwesomeIcon icon={faCheck} className="text-orange-500 text-xs" />
                                            )}
                                        </button>
                                    ))}
                                    <div className={`px-3 py-2 border-t ${
                                        enabled 
                                            ? 'border-gray-700' 
                                            : 'border-gray-200'
                                    }`}>
                                        <p className={`text-xs ${
                                            enabled ? 'text-gray-400' : 'text-gray-500'
                                        }`}>
                                            <FontAwesomeIcon icon={faInfoCircle} className="mr-1" />
                                            Traduction via Google Translate
                                        </p>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>

                    {/* Réseaux sociaux */}
                    {/* Autres réseaux sociaux */}
                    {items.map(item => (
                        <a key={item.link} href={item.link} target="_blank" rel="noreferrer" className="flex items-center justify-center hover:bg-neutral-700/20 rounded-xl transition-all duration-150 p-2 px-3" aria-label={item.name || item.link}>
                            <FontAwesomeIcon icon={item.icon} className="text-3xl" />
                        </a>
                    ))}
                    {/* Bouton contact */}
                    <button
                        onClick={() => setShowContactForm(true)}
                        className="flex items-center justify-center hover:bg-neutral-700/20 rounded-xl transition-all duration-150 p-2 px-3"
                        aria-label="Contactez-moi"
                    >
                        <FontAwesomeIcon icon={faEnvelope} className="text-3xl" />
                    </button>
    {/* Modal formulaire de contact */}
    {showContactForm && (
        <ContactForm enabled={enabled} isOpen={showContactForm} onClose={() => setShowContactForm(false)} />
    )}
                    
                    {/* Switch thème */}
                    {/* Switch thème responsive */}
                    {/* Mobile : bouton rond simple (<400px) */}
                    <div className="block xs:hidden">
                        <button
                            onClick={() => setEnabled(!enabled)}
                            aria-label="Changer le thème"
                            className="w-[28px] h-[28px] rounded-full flex items-center justify-center bg-transparent border-none shadow-md focus:outline-none"
                            style={{
                                background: enabled ? '#23272F' : '#F7F7F7',
                                border: enabled ? '1px solid #000' : '1px solid #E4ECFB',
                                transition: 'none'
                            }}
                        >
                            {enabled ? (
                                // SVG lune minimaliste + 3 étoiles
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                                    <circle cx="16" cy="16" r="14" fill="#23272F" />
                                    <path d="M20 16c0 2.21-1.79 4-4 4a4 4 0 0 1 0-8c.3 0 .6.03.88.09A5.5 5.5 0 1 0 20 16z" fill="#FFD700" />
                                    <circle cx="8" cy="10" r="0.5" fill="#FFFDEB" />
                                    <circle cx="24" cy="12" r="0.4" fill="#FFFDEB" />
                                    <circle cx="13" cy="23" r="0.3" fill="#FFFDEB" />
                                </svg>
                            ) : (
                                // SVG soleil ultra minimaliste : simple cercle doré
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                                    <circle cx="16" cy="16" r="10" fill="#FFD700" />
                                </svg>
                            )}
                        </button>
                    </div>
                    {/* Switch intermédiaire (xs: ≥400px et <640px) */}
                    <div className="hidden xs:block sm:hidden">
                        <Switch
                            checked={enabled}
                            onChange={setEnabled}
                            className="relative inline-flex h-[30px] w-[50px] shrink-0 cursor-pointer rounded-full border-2 border-transparent shadow-sm transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                            style={
                                enabled ? {
                                    backgroundColor : '#5D5E60D8',
                                } : {
                                    backgroundColor : '#E4ECFB',
                                }
                            }
                        >
                            <span
                                aria-hidden="true"
                                className={`${enabled ? 'translate-x-5' : 'translate-x-0'} pointer-events-none h-[26px] w-[26px] flex items-center justify-center transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`}
                                style={
                                    enabled ? {
                                        background: '#23272F',
                                        border: '1px solid #000'
                                    } : {
                                        background: '#F7F7F7',
                                        border: '1px solid #E4ECFB'
                                    }
                                }
                            >
                            {enabled ? (
                                // SVG lune minimaliste + 3 étoiles
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                                    <circle cx="16" cy="16" r="14" fill="#23272F" />
                                    <path d="M20 16c0 2.21-1.79 4-4 4a4 4 0 0 1 0-8c.3 0 .6.03.88.09A5.5 5.5 0 1 0 20 16z" fill="#FFD700" />
                                    <circle cx="8" cy="10" r="0.5" fill="#FFFDEB" />
                                    <circle cx="24" cy="12" r="0.4" fill="#FFFDEB" />
                                    <circle cx="13" cy="23" r="0.3" fill="#FFFDEB" />
                                </svg>
                            ) : (
                                // SVG soleil ultra minimaliste : simple cercle doré
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                                    <circle cx="16" cy="16" r="10" fill="#FFD700" />
                                </svg>
                            )}
                            </span>
                        </Switch>
                    </div>
                    {/* Desktop/tablette : Switch classique (sm: ≥640px) */}
                    <div className="hidden sm:block">
                        <Switch
                            checked={enabled}
                            onChange={setEnabled}
                            className="relative inline-flex h-[38px] w-[74px] shrink-0 cursor-pointer rounded-full border-2 border-transparent shadow-sm transition-colors duration-200 ease-in-out focus:outline-none focus-visible:ring-2 focus-visible:ring-white focus-visible:ring-opacity-75"
                            style={
                                enabled ? {
                                    backgroundColor : '#5D5E60D8',
                                } : {
                                    backgroundColor : '#E4ECFB',
                                }
                            }
                            aria-label="Changer le thème (sombre ou clair)"
                        >
                            <span
                                aria-hidden="true"
                                className={`${enabled ? 'translate-x-9' : 'translate-x-0'} pointer-events-none h-[34px] w-[34px] flex items-center justify-center transform rounded-full shadow-lg ring-0 transition duration-200 ease-in-out`}
                                style={
                                    enabled ? {
                                        background: '#23272F',
                                        border: '1px solid #000'
                                    } : {
                                        background: '#F7F7F7',
                                        border: '1px solid #E4ECFB'
                                    }
                                }
                            >
                            {enabled ? (
                                // SVG lune minimaliste + 3 étoiles (desktop)
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                                    <circle cx="16" cy="16" r="14" fill="#23272F" />
                                    <path d="M20 16c0 2.21-1.79 4-4 4a4 4 0 0 1 0-8c.3 0 .6.03.88.09A5.5 5.5 0 1 0 20 16z" fill="#FFD700" />
                                    <circle cx="8" cy="10" r="0.5" fill="#FFFDEB" />
                                    <circle cx="24" cy="12" r="0.4" fill="#FFFDEB" />
                                    <circle cx="13" cy="23" r="0.3" fill="#FFFDEB" />
                                </svg>
                            ) : (
                                // SVG soleil ultra minimaliste : simple cercle doré (desktop)
                                <svg viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" width="100%" height="100%">
                                    <circle cx="16" cy="16" r="10" fill="#FFD700" />
                                </svg>
                            )}
                            </span>
                        </Switch>
                    </div>

                </div>
            </div>
            <div className="flex justify-center md:justify-start items-center space-x-4 py-2">
                {navItems.map(item => (
                    <Link
                        key={item.label}
                        href={item.href}
                        className={`flex items-center justify-center rounded-xl transition-all duration-150 cursor-pointer
                            ${enabled ? 'text-white/70 hover:text-white' : 'text-black/50 hover:text-black'}
                            ${router.asPath === item.href ? (enabled ? 'text-orange-400 font-bold' : 'text-orange-500 font-bold') : ''}
                        `}
                    >
                        <FontAwesomeIcon icon={item.icon} className="mr-2" />{item.label}
                    </Link>
                ))}
            </div>
        </div>
    </>
}

export default Header;
